<template>
  <div class="p-pnt">
    <ModalError :visible="showModalError" :errorType="errorType" ></ModalError>
    <div class="l-container sm-default-px">
      <!-- <div class="c-box mb-16 mt-px"> -->
      <!-- ライフエール独自対応 >>>>> -->
      <Header
        v-model="menuBasicInfo"
        :bodyEmail="bodyEmail"
        @handleFavorite="handleFavorite"
      />
      <!-- ライフエール独自対応 <<<<< -->
      <MenuNavigation :isRakutenFlg="isRakutenFlg" />
      <!-- ライフエール独自対応 >>>>> -->
      <img
        v-if="isAddedFavorite"
        :src="imageUrl"
        class="copy"
      />
      <!-- ライフエール独自対応 <<<<< -->
      <router-view></router-view>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
import Header from './Header'
import MenuNavigation from './MenuNavigation'

import mark_watched from '@/mixins/mark_watched'
import { BREADCRUMBS } from '@/store/modules/app/actions'

export default {
  name: 'MenuMainContainer',
  components: {
    Header,
    MenuNavigation
  },
  mixins: [mark_watched],
  data() {
    return {
      showModalError: false,
      errorType: '',
      menuBasicInfo: null,
      isRakutenFlg: false,
      // ライフエール独自対応 >>>>>
      isAddedFavorite: false,
      // ライフエール独自対応 <<<<<
      bodyEmail:{
        memberName: '',
        menuNo: '',
        menuNm: '',
        planId: '',
        roomId: '',
        planNm: ''
      }
    }
  },
  created() {
    this.getMenuBasicInfo()
  },
  mounted() {},
  watch: {
    /** ルートごとに異なるタイトルをセットする */
    watchDocumentTitleTargets() {
      if (this.menuBasicInfo == null) return
      switch (this.$route.name) {
      case 'Menu Detail':
        document.title = `${this.menuBasicInfo.menuNm}｜割引・特別優待ならベネフィットステーション`
        break
      case 'MenuPlanList':
        document.title = `${this.menuBasicInfo.menuNm}｜割引・特別優待ならベネフィットステーション`
        break
      case 'plan_details':
        this.$meta.setDocumentTitle(`メニュー「${this.menuBasicInfo.menuNm}」（プラン詳細）`)  
        break
      }
    },
    //queryが変わった時にパンくずのリンクに反映する
    '$route.query': {
      handler: "getMenuBasicInfo",
    }
  },
  computed: {
    // ライフエール独自対応 >>>>>
    imageUrl() {
      if (
        !this.menuBasicInfo ||
        !this.menuBasicInfo.menuImages ||
        !this.menuBasicInfo.menuImages[0] ||
        !this.menuBasicInfo.menuImages[0].imageUrl
      ) {
        return "";
      }
      return this.menuBasicInfo.menuImages[0].imageUrl;
    },
    // ライフエール独自対応 <<<<<
    /**
     * titleタグをルートごとに変更するため、以下の２つをwatch対象にする
     * 1 メニュー名（menuNm）を保持しているmenuBasicInfo
     * 2 現在のルート名
     * */
     watchDocumentTitleTargets() {
      return [this.menuBasicInfo, this.$route]
    }
  },
  methods: {
    // ライフエール独自対応 >>>>>
    handleFavorite(isAddedFavorite) {
      this.isAddedFavorite = isAddedFavorite;
    },
    // ライフエール独自対応 <<<<<
    getBodyEmail() {
      this.bodyEmail = {
        memberName: _.get(this.$store, 'getters.bs_app.info_user.username', ''),
        menuNo: _.get(this.menuBasicInfo, 'menuInformation.menuNo', null),
        menuNm: _.get(this.menuBasicInfo, 'menuInformation.menuNm', null),
        planId: _.get(this.menuBasicInfo, 'planBasicInfo.planId', null),
        roomId: _.get(this.menuBasicInfo, 'roomBasicInfo.roomId', null),
        planNm: _.get(this.menuBasicInfo, 'planBasicInfo.planNm', null)
      }
    },

    getMenuBasicInfo() {
      const { menuNo } = this.$route.params
      this.$loading.show()
      this.$repositories('menu')
        .getMenuBasicInfo(menuNo)
        .then(
          (result) => {
            this.menuBasicInfo = result.data
            this.getBodyEmail();
            // update breadcrumbs
            const breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
            if (breadcrumbs.length < 3) {
              breadcrumbs.push({
                path: `/menus/${menuNo}`,
                query: this.$route.query,
                title: _.get(this.menuBasicInfo, 'menuNm', '')
              })
            }
            this.$store.dispatch(BREADCRUMBS, breadcrumbs)

            // 楽天の場合は、フォトギャラリーを非表示にする(初回リリース時対応)
            if (this.menuBasicInfo.extSystemCd == 'RakutenT') {
              this.isRakutenFlg = true;
            }
            this.$loading.hide()
          },
          (error) => {
            this.$loading.hide()
            if (error && error.status == 401) {
              this.showModalError = true
            }
          }
        )
    }
  }
}
</script>

<!-- ライフエール独自対応 >>>>> -->
<style lang="scss" scoped>
.copy {
  position: absolute !important;
  width: 200px;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;
  animation-name: favImg;
  animation-duration: 2.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  z-index: 2000;
}

@keyframes favImg {
  0% {
    width: 200px;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  5% {
    top: 30%;
    left: 45%;
    opacity: 0.8;
  }

  100% {
    width: 10px;
    height: auto;
    top: 100%;
    left: 37.5%;
    opacity: 0;
  }
}
</style>
<!-- ライフエール独自対応 <<<<< -->
